import React from 'react';
import AvatarWithFlag from 'components/AvatarWithFlag/AvatarWithFlag';
import FeatureCardLayout from './FeatureCardLayout';
import './AnimatedBorderCard.css';

interface AnimatedBorderCardProps {
  isElite: boolean;
  avatarUrl?: string | null;
  username?: string;
  borderColor1?: string | null;
  borderColor2?: string | null;
  onOpenBorderColorModal?: () => void;
}

const AnimatedBorderCard: React.FC<AnimatedBorderCardProps> = ({
  isElite,
  avatarUrl,
  username,
  borderColor1,
  borderColor2,
  onOpenBorderColorModal,
}) => {
  const preview = (
    <div className="border-card-preview">
      <AvatarWithFlag
        avatarUrl={avatarUrl}
        username={username || 'Elite'}
        size={64}
        isElite={true}
        showAnimatedBorder={true}
        borderColor1={borderColor1 || '#FFD700'}
        borderColor2={borderColor2 || '#9B59B6'}
      />
    </div>
  );

  const cta = isElite ? (
    <button className="feature-card-btn" onClick={onOpenBorderColorModal}>
      Customize Colors
    </button>
  ) : (
    <button className="feature-card-btn feature-card-btn--secondary" onClick={onOpenBorderColorModal}>
      Try It Out
    </button>
  );

  return (
    <FeatureCardLayout
      title="Animated Avatar Border"
      description="Your avatar gets a glowing animated gradient border visible across the entire platform. Customize the colors to match your style."
      previewContent={preview}
      ctaContent={cta}
      className="border-card"
    />
  );
};

export default AnimatedBorderCard;
